import Table from "./table.component";

export default Table;
